/*
 * @Author: Hyman Choi
 * @Date: 2021-02-02 11:00:45
 * @LastEditTime: 2021-11-16 16:15:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\api\eventSquare.js
 */
import request from '@/utils/request'
import config from '@/utils/config'

/**
 *
 *
 * @param {*} params
 */
export function getActivityList(params) {
  return request({
    url: config.API_MEDICAL + '/Api/V1/AdminActivitys/ActivityList',
    method: 'get',
    params
  })
}

/**
 *
 *
 * @param {*} data
 */
export function addActivity(data) {
  return request({
    url: config.API_MEDICAL + '/Api/V1/AdminActivitys/Add',
    method: 'post',
    data
  })
}

/**
 *
 *
 * @param {*} params
 */
export function deleteActivity(params) {
  return request({
    url: config.API_MEDICAL + '/Api/V1/AdminActivitys/Delete',
    method: 'delete',
    params
  })
}
